import { z } from "zod";

const OccupancyMonthlyReportDataV4Schema = z.object({
    month: z.string(),
    property_id: z.string().nullable(),
    occupancy: z.string(),
});

export const OccupancyMonthlyReportResponseV4Schema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number().int(),
    data: z.array(OccupancyMonthlyReportDataV4Schema),
});

export type OccupancyMonthlyReportDataV4 = z.infer<typeof OccupancyMonthlyReportDataV4Schema>;
export type OccupancyMonthlyReportResponseV4 = z.infer<typeof OccupancyMonthlyReportResponseV4Schema>;